"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AGRefinementList_styles_1 = __importDefault(require("./AGRefinementList.styles"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var RefinementList = function (_a) {
    var items = _a.items, isFromSearch = _a.isFromSearch, refine = _a.refine, searchable = _a.searchable, searchForItems = _a.searchForItems;
    return (react_1.default.createElement(AGRefinementList_styles_1.default, null,
        searchable && (react_1.default.createElement("input", { type: "search", className: "search", onChange: function (event) { return searchForItems(event.currentTarget.value); }, placeholder: "Zoek op filter" })),
        items.length > 0 &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: "header" }, "Filter op:"),
                react_1.default.createElement("ul", { className: "list" }, items && items.map(function (item) { return (react_1.default.createElement("li", { key: item.label, className: "item" },
                    react_1.default.createElement("a", { href: "#", className: "link", onClick: function (event) {
                            event.preventDefault();
                            refine(item.value);
                        } },
                        react_1.default.createElement("input", { className: "checkbox", type: "checkbox", checked: item.isRefined, readOnly: true }),
                        react_1.default.createElement("label", { className: "label" }, isFromSearch ? (react_1.default.createElement(react_instantsearch_dom_1.Highlight, { attribute: "label", hit: item, tagName: "mark" })) : (item.label))))); }))),
        items.length === 0 &&
            react_1.default.createElement("p", { className: "empty" }, "Geen waardes gevonden om op te filteren")));
};
var AGRefinementList = react_instantsearch_dom_1.connectRefinementList(RefinementList);
exports.default = AGRefinementList;
